<template>
  <ValidationObserver
    ref="FilterObserver" >
    <div>
      <label
        for="p-key"
        class="flex flex-align-center" >
        Filters
      </label>
    </div>

    <div
      v-for="(filter, index) in selectedFilters"
      :key="index"
      class="filter-wrapper">

      <template v-if="index">
        <multiselect
          v-model="operator"
          class="flex-options hide-tags no-selected-background filter-operator"
          :options="filterOperators"
          :multiple="false"
          :show-labels="false"
          :show-no-results="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="true"
          :allow-empty="false"
          :searchable="false" >
          <template
            slot="option"
            slot-scope="props">
            <div class="flex flex-align-center">
              <p class="greedy ellipsis p-0 m-0">{{ props.option }}</p>
            </div>
          </template>
        </multiselect>
      </template>

      <div
        class="filter-row"
        :class="{ single: selectedFilters.length === 1 }" >
        <SBIcon
          v-if="forceRemoveIcon || selectedFilters.length > 1"
          class="show-hand"
          :icon="SBIconList.CLOSE_THIN"
          color="#979A9B"
          :hover-size="16"
          hover-icon-color="#5E6264"
          :size="8"
          @click="removeFilterOption(index)"
          @click.native.stop.prevent />

        <!-- First input for selecting filter type -->
        <ValidationProvider
          v-if="filterTypes"
          ref="filterValidationProvider1Ref"
          name="filter"
          rules="required">
          <!-- .filter(f => !selectedTypes.includes(f.type)) -->
          <multiselect
            v-model="selectedFilters[index].value"
            placeholder="Select"
            class="flex-options hide-tags no-selected-background filter-type no-shrink"
            :options="filterTypes"
            label="name"
            track-by="type"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="true"
            :allow-empty="false"
            :searchable="false"
            @input="typeChange(index)" >
            <template
              slot="singleLabel"
              slot-scope="props"
              class="tag-scroll-wrapper flex flex-align-center">
              <img
                :src="props.option.icon"
                :alt="props.option.name"
                class="mr-2" >
              <p class="greedy ellipsis p-0 m-0">{{ props.option.name }}</p>
            </template>

            <template
              slot="option"
              slot-scope="props">
              <div
                class="flex flex-align-center w-100"
                :class="{ ellipsis: customEllipsis[index] }" >
                <img
                  :src="props.option.icon"
                  :alt="props.option.name"
                  class="mr-2" >
                <p class="greedy ellipsis p-0 m-0">{{ props.option.name }}</p>
                <SBIcon
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.bluePrimary"
                  :size="9"
                  class="mr-0" />
              </div>
            </template>
          </multiselect>
        </ValidationProvider>

        <!-- Second input for selecting the operator type -->
        <ValidationProvider
          v-if="selectedFilters[index] && selectedFilters[index].value && operatorTypes[selectedFilters[index].value.type] && operatorTypes[selectedFilters[index].value.type].length > 1"
          v-slot="{ errors }"
          ref="filterValidationProviderSecondRef"
          name="filter"
          rules="required"
          slim >
          <multiselect
            v-model="selectedFilters[index].operator"
            placeholder="Select"
            class="flex-options hide-tags no-selected-background filter-comparison no-shrink"
            :options="operatorTypes[selectedFilters[index].value.type]"
            label="name"
            track-by="value"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="true"
            :allow-empty="false"
            :searchable="false"
            @input="operatorChange(index)" >
            <template
              slot="option"
              slot-scope="props">
              <div class="flex flex-align-center w-100">
                <p>{{ props.option.name }}</p>
                <SBIcon
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.bluePrimary"
                  :size="9"
                  class="mr-0" />
              </div>
            </template>
          </multiselect>
        </ValidationProvider>
        <div
          v-else-if="selectedFilters[index] && selectedFilters[index].value && operatorTypes[selectedFilters[index].value.type] && operatorTypes[selectedFilters[index].value.type].length"
          class="fake-multiselect flex-options filter-comparison no-shrink" >
          <!-- {{ selectedFilters[index].operator ? selectedFilters[index].operator.name : 'Select' }} -->
          {{ operatorTypes[selectedFilters[index].value.type][0].name }}
        </div>

        <!-- Third input for filter data -->
        <ValidationProvider
          v-if="dataValues[index].type === 'multiselect' && dataValues[index].options && dataValues[index].options.length"
          v-slot="{ errors }"
          :ref="`filterValidationProviderThirdMultiselectRef-${index}`"
          :name="`filter-${index}`"
          rules="required"
          slim >

          <!-- Component for list type data -->
          <b-dropdown
            id="dropdown-form-btn2"
            :ref="`ref-${index}-third-step`"
            v-model="selectedFilters[index].data"
            class="m-0 p-0 filter-data list-data"
            toggle-class="ellipsis" >
            <template #button-content>
              <template v-if="!selectedFilters[index].data || !selectedFilters[index].data.length">
                <p class="light">Select</p>
              </template>
              <template v-else>
                <div
                  :ref="`multiselectListRef-${index}`"
                  class="countries-btn flex flex-align-center"
                  :class="{ ellipsis: customEllipsis[index] }" >
                  <div
                    v-for="(country, i) in selectedFilters[index].data"
                    :key="i"
                    class="flex flex-align-center no-shrink ellipsis" >
                    <span
                      v-if="i"
                      class="country-operator"
                      @click.stop.prevent="dataOperatorChange(index)" >{{ dataOperator[index] }}</span>
                    <p
                      class="no-shrink ellipsis"
                      :class="{ pill: dataValues[index].multiple }"
                    >{{ country.name }}</p>
                  </div>
                </div>
              </template>
            </template>
            <b-dropdown-form
              v-if="dataValues[index].options && dataValues[index].options.length > 5"
              class="SB-border bottom search-element">
              <b-form-group
                @submit.stop.prevent>
                <b-form-input
                  id="dropdown-search"
                  v-model="searchQuery"
                  size="sm"
                  placeholder="Search" />
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-item-button
              v-for="(option, i) in dataValues[index].options.filter(o => o.name.toLowerCase().includes(searchQuery.toLowerCase()))"
              :key="i"
              button-class="flex flex-align-center"
              @click.native.capture.stop="selectOption(index, option)" >
              <p class="greedy ellipsis">{{ option.name }}</p>
              <SBIcon
                v-if="selectedFilters[index].data && selectedFilters[index].data.map(c => c.value).includes(option.value)"
                class="ml-1"
                :icon="SBIconList.DONE_TICK"
                :color="SBColors.bluePrimary"
                :size="9"/>
            </b-dropdown-item-button>
            <div
              v-if="!dataValues[index].options.filter(o => o.name.toLowerCase().includes(searchQuery.toLowerCase())).length"
              style="text-align: center !important; padding: 24px 20px;" >
              <span class="emoji-fix">😐</span> We could't find anything for <span style="font-weight: 500 !important;">{{ searchQuery }}</span>
            </div>
          </b-dropdown>
        </ValidationProvider>
        <!-- Component for keywords input data -->
        <ValidationProvider
          v-else-if="dataValues[index].type === 'keywords'"
          v-slot="{ errors }"
          :ref="`filterValidationProviderThirdMultiselectRef-${index}-3`"
          :name="`filter-${index}-3`"
          rules="required|validChild"
          slim >
          <TagInput
            :ref="`tags${index}Ref`"
            v-model="selectedFilters[index].data"
            class="filter-data"
            :show-condition="!dataValues[index].singleTag"
            :single-tag="dataValues[index].singleTag"
            :single-line="true" />
        </ValidationProvider>
      </div>
      <div
        v-if="selectedFilters && selectedFilters[index] && selectedFilters[index].value && selectedFilters[index].value.type === 'business_hours'"
        class="option-link-details flex flex-align-center show-hand"
        :class="{ single: selectedFilters.length === 1 }"
        @click="setupBusinessHours">
        <p>Set-up and manage your business hours</p>
        <SBIcon
          :icon="SBIconList.ARROW"
          :color="SBColors.bluePrimary"
          class="p-0 m-0 mr-2"
          :border-radius="0"
          :size="10"
          :rotate="-135" />
      </div>
    </div>
    <span
      class="add-filter flex flex-align-center action"
      :class="{ disabled: noMoreFilters }"
      @click.stop="addFilter" >
      <SBIcon
        :icon="SBIconList.PLUS"
        :color="SBColors.bluePrimary"
        class="p-0 m-0 mr-2"
        :border-radius="0"
        :size="8" />
      Add filter</span>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import Multiselect from 'vue-multiselect';
import TagInput from '@/components/common/TagInput';
import ToasterMixin from '@/mixins/Toaster';
import { debounce } from 'debounce';
import randomString from '@/helpers/randomString';

export default {
  name: 'FilterBlock',
  components: {
    SBIcon,
    Multiselect,
    TagInput,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    node: {
      type: Object,
      required: false,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    forceRemoveIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      operator: 'and',
      filterOperators: [
        'and',
        'or',
      ],
      dataOperator: [],
      customEllipsis: [],
      searchQuery: '',
      dataOperators: [],
      selectedFilters: [],
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI',
      flowsDefinitions: 'flows/flowsDefinitions',
      flowData: 'flows/flowData',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    filterDefinitions() {
      const filterDefinitions = this.flowsDefinitions.blocks.definitions.logic.find(block => block.meta.type === 'FILTER');
      if (filterDefinitions) {
        return filterDefinitions;
      }
      return [];
    },
    filterTypes() {
      const filter = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
      const filterTypes = [...Object.values(this.filterDefinitions.definition.elements)];
      if (filter.definition.limits.unique_elements) {
        filterTypes.forEach((filter) => {
          if (this.selectedTypes.includes(filter.type)) {
            filter.$isDisabled = true;
          } else {
            filter.$isDisabled = false;
          }
        });
      }
      return filterTypes;
    },
    operatorTypes() {
      const operatorTypes = {};
      this.filterDefinitions.definition.elements.forEach((e) => {
        operatorTypes[e.type] = e.operator;
      });
      return operatorTypes;
    },
    selectedTypes() {
      return this.selectedFilters.filter(f => f.value && f.value.type).map(f => f.value.type);
    },
    dataValues() {
      const dataValues = [];
      this.selectedFilters.forEach((filter, index) => {
        dataValues[index] = {};
        if (!filter.value) {
          return;
        }
        const targetFilter = this.filterDefinitions.definition.elements.find(e => e.type === filter.value.type);
        // Rules for the data filter
        //    - if the filter has a values.value array populated, then the data filter is a multiselect
        //    - if the filter has a 'value_type' === 'str', then the data filter is single option
        //    - if the filter has a 'value_type' === 'list' then the data filter is a multiselect
        //    - if the filter has a 'values.operator', then the selected options have a operator in between
        //    - if the filter has a 'values.operator.values' and option has 'allowed_on' then that operator is only available in combination with the selectedFilter.operator

        // Determine the type of the data filter
        if (targetFilter.values.value && targetFilter.values.value.length) {
          dataValues[index] = {
            type: 'multiselect',
            options: targetFilter.values.value,
            multiple: targetFilter.value_type === 'list',
          };
        } else {
          dataValues[index] = {
            type: 'keywords',
            singleTag: this.selectedFilters[index].operator && this.selectedFilters[index].operator.value_type === 'str',
          };
        }
      });
      return dataValues;
    },
    noMoreFilters() {
      const filter = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
      if (filter.definition.limits.max_elements) {
        return this.selectedTypes.length >= filter.definition.limits.max_elements;
      }
      return false;
    },
  },
  watch: {
    selectedFilters: {
      handler() {
        this.emitChange();
      },
      deep: true,
    },
  },
  mounted() {
    this.addFilter();
    if (this.editMode) {
      this.mountedEditMode();
    }
  },
  methods: {
    ...mapActions({
      addFlowBlock: 'flows/addFlowBlock',
      editFlowBlock: 'flows/editFlowBlock',
    }),
    addFilter() {
      if (this.noMoreFilters) {
        return;
      }
      const filter = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
      this.selectedFilters.push({
        data: null,
        operator: null,
        value: filter.definition.limits.unique_elements ? this.filterTypes.find(f => !this.selectedTypes.includes(f.type)) : null,
      });
      // setTimeout(() => {
      //   if (this.selectedFilters[this.selectedFilters.length - 1].operator === null) {
      //     this.selectedFilters[this.selectedFilters.length - 1].operator = this.operatorTypes[this.selectedFilters[this.selectedFilters.length - 1].value.type][0];
      //   }
      //   this.setDataOperators(this.selectedFilters.length - 1);
      // }, 3000);
      this.$nextTick(() => {
        this.selectedFilters[this.selectedFilters.length - 1].operator = this.operatorTypes[this.selectedFilters[this.selectedFilters.length - 1].value.type][0];
        this.setDataOperators(this.selectedFilters.length - 1);
      });
    },
    removeFilterOption(index) {
      if (this.selectedFilters.length === 1) {
        // This is the last filter, remove the block in case filter block is used on another component where the whole filter is removed when the last filter is removed.
        // TODO make this a prop on rewrite (allowRemoveLastFilterBlock or something like that)
        this.$emit('removeLast');
        return;
      }
      this.selectedFilters.splice(index, 1);
      this.setDataOperators();
    },
    mountedEditMode() {
      try {
        this.operator = this.node.blockData.params.operator.value;
        this.selectedFilters = this.node.blockData.params.elements.map((element) => {
          const filterDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
          const filterTypeDefinition = filterDefinition.definition.elements.find(e => e.type === element.type);
          const value = this.filterTypes.find(f => f.type === element.type);
          let data;
          if (Array.isArray(element.value.value)) {
            if (filterTypeDefinition.type === 'country') {
              data = [
                ...element.value.value.map(v => filterTypeDefinition.values.value.find(fv => fv.value === v)),
              ];
            } else {
              data = {
                tags: element.value.value.map(v => ({
                  tag: v,
                  id: randomString(),
                })),
              };
            }
          } else if (filterTypeDefinition.type === 'inbound_message') {
            data = { tags: [{ tag: element.value.value }] };
          } else {
            data = this.flowsDefinitionsUI.logic.FILTER.values[value.type].value.find(v => v.value === element.value.value);
            data = [data];
          }
          return {
            value,
            operator: this.operatorTypes[element.type].find(o => o.value === element.operator.value),
            data,
          };
        });
        setTimeout(() => {
          this.selectedFilters.forEach((_, i) => this.dataChange(i));
        }, 10);
        const selectedBkp = JSON.parse(JSON.stringify(this.selectedFilters));
        // operatorTypes are generated based on the filter type from the selectedFilters so we have to wait for the selectedFilters to be populated and then set the operators by setting the selctedFilters once again overriding the default values
        setTimeout(() => {
          this.selectedFilters = selectedBkp;
        }, 0);
      } catch (error) {
        console.error(error);
      }
    },
    emitChange: debounce(function f() {
      const filterValue = {
        value: null,
        valid: false,
      };

      this.$refs.FilterObserver.validate()
        .then((result) => {
          filterValue.valid = result;
          if (result) {
            const elements = [];
            this.selectedFilters.forEach((filter, index) => {
              elements.push({
                type: filter.value.type,
                operator: { value: filter.operator.value },
                value: this.getValue(filter, index),
              });
            });
            const filter = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
            let operator;
            if (filter) {
              operator = filter.definition.operator.values.find(o => o.value === this.operator).value;
            }

            filterValue.value = {
              block: {
                category: 'logic',
                type: 'FILTER',
                params: {
                  elements,
                  operator: {
                    value: operator,
                  },
                },
              },
            };
          }

          this.$emit('input', filterValue);
        })
        .catch((error) => { });
    }, 300),
    setDataOperators() {
      this.selectedFilters.forEach((filter, index) => {
        this.dataOperators[index] = [];
        if (!filter.value) {
          return;
        }
        const targetFilter = this.filterDefinitions.definition.elements.find(e => e.type === filter.value.type);
        if (targetFilter.values.operator && targetFilter.values.operator.values) {
          this.dataOperators[index] = targetFilter.values.operator.values;
        } else {
          this.dataOperators[index] = [];
        }

        if (this.dataOperators[index].length && this.dataOperators[index].some(o => typeof o.allowed_on === 'object')) {
          this.dataOperators[index] = this.dataOperators[index].filter(o => o.allowed_on.operator.operator === this.selectedFilters[index].operator.value);
        }

        if (this.dataOperators[index].length && this.dataOperators[index].every(o => o.value !== this.dataOperator[index])) {
          this.dataOperator[index] = this.dataOperators[index][0].value;
        }
        if (!this.dataOperators[index].length) {
          this.dataOperator[index] = null;
        }
      });

      // reset current dataOperator if needed
      this.dataOperators.length = this.selectedFilters.length;
      this.dataOperator.length = this.selectedFilters.length;
      this.dataOperator = [...this.dataOperator];
    },
    dataOperatorChange(index = 0) {
      const currentDataOperatorIndex = this.dataOperators[index].findIndex(o => o.value === this.dataOperator[index]);
      if (currentDataOperatorIndex === this.dataOperators[index].length - 1) {
        this.dataOperator[index] = this.dataOperators[index][0].value;
      } else {
        this.dataOperator[index] = this.dataOperators[index][currentDataOperatorIndex + 1].value;
      }
    },
    typeChange(index) {
      this.selectedFilters[index].operator = null;
      this.selectedFilters[index].data = null;
      this.$nextTick(() => {
        this.selectedFilters[index].operator = this.operatorTypes[this.selectedFilters[index].value.type][0];
        this.setDataOperators(index);
      });
    },
    operatorChange(index) {
      this.setDataOperators(index);
    },
    dataChange(index) {
      this.$nextTick(() => {
        // Check if the field is too long and put the custom ellipsis on it
        if (this.$refs[`filterValidationProviderThirdMultiselectRef-${index}`] && this.$refs[`multiselectListRef-${index}`] && ((this.$refs[`filterValidationProviderThirdMultiselectRef-${index}`][0].$el.scrollWidth - 40) < this.$refs[`multiselectListRef-${index}`][0].scrollWidth)) {
          this.customEllipsis[index] = true;
        } else {
          this.customEllipsis[index] = false;
        }
        this.customEllipsis = [...this.customEllipsis];
      });
    },
    selectOption(index, option) {
      if (!this.dataValues[index].multiple) {
        this.selectedFilters[index].data = [option];
      } else if (this.selectedFilters[index].data && this.selectedFilters[index].data.map(c => c.value).includes(option.value)) {
        this.selectedFilters[index].data = this.selectedFilters[index].data.filter(c => c.value !== option.value);
      } else {
        if (!this.selectedFilters[index].data) {
          this.selectedFilters[index].data = [];
        }
        this.selectedFilters[index].data.push(option);
      }
      this.dataChange(index);
      if ((!this.dataValues[index] || !this.dataValues[index].multiple) && this.$refs[`ref-${index}-third-step`]) {
        this.$refs[`ref-${index}-third-step`][0].hide(true);
      }
    },
    filterValue(filter) {
      if (filter.type.value === 'business_hours') {
        return this.flowsDefinitionsUI.logic.FILTER.values[filter.type.value].find(o => o.value === filter.data.value);
      }
      return filter.data.value;
    },
    getValue(filter, index) {
      const filterDefinition = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
      const filterTypeDefinition = filterDefinition.definition.elements.find(e => e.type === filter.value.type);
      // Operator value type overrides filter defined value type
      if (filter && filter.operator && filter.operator.value_type) {
        filterTypeDefinition.value_type = filter.operator.value_type;
      }
      if (this.dataValues[index].type === 'multiselect') {
        const operator = this.dataOperators[index].find(d => d.value === this.dataOperator[index]);
        return {
          operator: {
            value: operator ? operator.value : null,
          },
          value: filterTypeDefinition.value_type === 'list' ?
            filter.data && filter.data.length ? filter.data.map(f => f.value) : [] :
            filter.data && filter.data.length ? filter.data[0].value : null,
        };
      }
      if (this.dataValues[index].type === 'keywords') {
        const operator = filter.value.values.operator.values.find(o => o.value === filter.data.condition);
        return {
          operator: {
            value: operator ? operator.value : null,
          },
          value: filterTypeDefinition.value_type === 'list' ?
            filter.data && filter.data.list && filter.data.list.length ? filter.data.list.filter(d => d.trim()) : [] :
            filter.data && filter.data.list && filter.data.list.length ? filter.data.list[0] : null,
        };
      }
      return {};
    },
    /**
     * Open the business hours setup page in a new tab
     */
    setupBusinessHours() {
      // SB-NOTE use router to open the page in a new tab
      const routeData = this.$router.resolve({ name: 'WorkingHours', params: { organisationId: this.currentOrganisation.id, businessId: this.flowData.business_uid } });
      window.open(routeData.href, '_blank');
    },
    submit(parentId, sibling = null, targetNodeId = null) {
      this.$refs.FilterObserver.validate()
        .then((result) => {
          if (result) {
            const elements = [];
            this.selectedFilters.forEach((filter, index) => {
              console.log(filter);
              elements.push({
                type: filter.value.type,
                operator: { value: filter.operator.value },
                value: this.getValue(filter, index),
              });
            });
            const filter = this.flowsDefinitions.blocks.definitions.logic.find(l => l.meta.type === 'FILTER');
            let operator;
            if (filter) {
              operator = filter.definition.operator.values.find(o => o.value === this.operator).value;
            }
            if (!this.editMode) {
              this.addFlowBlock({
                parentId,
                sibling,
                targetNodeId,
                block: {
                  category: 'logic',
                  type: 'FILTER',
                  params: {
                    elements,
                    operator: {
                      value: operator,
                    },
                  },
                },
              })
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('finished');
                  }
                });
            } else {
              this.editFlowBlock({
                blockId: this.node.id,
                block: {
                  category: 'logic',
                  type: 'FILTER',
                  params: {
                    elements,
                    operator: {
                      value: operator,
                    },
                  },
                },
              })
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('finished');
                  }
                });
            }
          } else {
            this.showToaster('There was an error. Try again later.', null, null, 'error');
          }
        })
        .catch((error) => {
          this.showToaster('There was an error. Try again later.', null, null, 'error');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: $blackPrimary !important;
  text-transform: none !important;
}

.filter-row {
  display: flex;
  align-items: center;
  column-gap: 8px;
  row-gap: 8px;

  .date-wrapper {
    column-gap: 10px;
    .down-arrow {
      position: absolute;
      top: 2px;
      right: 0;
    }
  }

  .el-date-editor {
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1) !important;
    border: solid 1px #cfd8dc !important;
    border-radius: 5px !important;
    width: 100% !important;
    z-index: 1;

    * {
      cursor: pointer !important;
    }

    &:hover {
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3) !important;
    }

    &:focus {
      outline: none !important;
      border: solid 1px #cfd8dc;
      box-shadow: 0 0 0 3px #bfdeff !important;
    }

    input {
      height: 30px;
      background-color: transparent;
      border: none !important;
      font-size: 14px;
      color: $blackPrimary;
      padding-left: 10px !important;
      padding-right: 23px !important;
    }

    .el-input__prefix {
      display: none !important;
    }

    .el-input__suffix {
      display: none !important;
    }
  }

  .close {
    cursor: pointer;
  }

  .multiselect {
    .multiselect__tags {
      padding-right: 0px;
      .multiselect__placeholder {
        padding-right: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &.filter-type {
      max-width: 180px;
      width: 180px;

      .multiselect__single {
        display: flex;
        padding-right: 28px;
        align-items: center;

        & > p {
          margin-top: 1px !important;
        }
      }
    }
    &.filter-comparison {
      max-width: 118px;
      width: 118px;
      ::v-deep .multiselect__tags {
        padding-right: 40px !important;
      }
    }
    &.filter-data {
      max-width: calc(100% - 304px);
      width: unset;
      flex-grow: 1;

      &.single-line {
        max-height: 30px !important;
        min-height: 30px !important;
      }
    }
  }

  div.fake-multiselect.filter-comparison {
    max-width: 118px;
    width: 118px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    border: solid 1px #cfd8dc;
    border-radius: 5px;
    height: 32px;
    font-size: 14px;
    color: $blackPrimary;
    background-color: $white;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
  }

  .filter-data {
    max-width: calc(100% - 338px); // 330
    width: unset;
    flex-grow: 1;
    max-height: 32px;
    &.tag-input {
      overflow: hidden;
    }
  }

  &.single .filter-data {
    max-width: calc(100% - 314px);
  }
}

#dropdown-form-btn, #dropdown-form-btn2 {
  height: 32px;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
  background: $white;
  color: $blackPrimary;
  border: 1px solid #CFD8DC;

  &:after {
    content: '';
    width: 30px;
    background: url('~@/assets/img/SB-Icons/down-arrow-light.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px;
    flex-shrink: 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 32px;
    // z-index: 1;
  }

  .light {
    color: $greyPrimary;
  }

  form {
    padding: 8px 10px;
    background: $greyUltralight;

    input {
      height: 26px !important;
      font-size: 14px !important;
      font-weight: normal !important;
      text-align: left !important;
      color: $greyPrimary;
      padding: 0px 5px !important;
    }
  }

  ::v-deep * {
    color: $blackPrimary;
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .countries-btn.ellipsis:after {
    content: "...";
    position: absolute;
    right: 30px;
    top: 0;
    background: #ffffff;
    padding: 7px 1px;
    z-index: 2;
    height: 100%;
    text-align: center;
  }

  .country-operator {
    cursor: pointer;
    font-size: 12px;
    color: $blackPrimary;
    margin-right: 5px;
    text-decoration-line: underline;
    text-decoration-style: dashed;
  }

  .pill {
    display: inline-flex !important;
    align-items: center !important;
    // cursor: default !important;
    border-radius: 9px !important;
    border: solid 1px $blackPrimary !important;
    background-color: $greyUltralight !important;
    color: $blackPrimary !important;
    padding: 0 7px 0px 7px !important;
    margin-right: 5px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }

  &:hover {
    background: $white;
    color: $blackPrimary;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3) !important;
  }

  &.show {
    box-shadow: 0 0 0 3px #bfdeff !important;
  }

  ::v-deep button.dropdown-toggle {
    padding: 0 30px 0 10px !important;
    text-align: left !important;
    background: transparent !important;
    &:after {
      content: none;
    }
  }

  ::v-deep ul.dropdown-menu {
    margin-top: 5px;
    width: 100%;

    li .dropdown-item:hover {
      background: $hover !important;
    }

    li.search-element {
      position: sticky;
      top: 0;
      z-index: 10;
    }

    li button {
      padding: 7px 12px !important;
      width: 100%;
      min-width: 100%;

      &:focus:not(:hover) {
        background: $white !important;
      }
    }
  }
}

.filter-operator ::v-deep {
  width: fit-content;
  box-shadow: none !important;
  height: 20px;
  min-height: 20px !important;
  margin-top: 10px;
  margin-bottom: 10px;
  .multiselect__select {
    mask-size: 8px auto !important;
    margin-top: -1px !important;
    height: 20px;
  }
  .multiselect__tags {
    border: none !important;
    background: transparent !important;
    padding-right: 25px !important;
    padding-left: 0px;
    min-height: 20px;
    .multiselect__single {
      background: transparent !important;
      font-size: 11px !important;
      font-weight: 500 !important;
      color: $blackUltralight !important;
      text-transform: uppercase !important;
    }
  }

  .multiselect__content-wrapper {
    margin-left: 9px;
    width: fit-content;
    ul li * {
      text-transform: capitalize !important;
    }
  }
}

.add-filter {
  margin-top: 15px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #2680eb;
  width: fit-content;

  &:hover {
    color: #3771cb;

    ::v-deep .sb-icon .mask {
      background-color: #3771cb !important;
    }
  }

  &.disabled {
    cursor: default;
    color: $greyPrimary;

    ::v-deep .sb-icon .mask {
      background-color: $greyPrimary !important;
    }

    &:hover {
      color: $greyPrimary;
      
      ::v-deep .sb-icon .mask {
        background-color: $greyPrimary !important;
      }
    }
  }
}

.option-link-details {
  width: fit-content;
  margin-top: 10px;

  &:not(.single) {
    margin-left: 24px;
  }

  p {
    color: $bluePrimary;
    font-size: 12px;
    font-weight: 500;
    margin-right: 5px;
  }

  &:hover {
    p {
      color: #3771cb !important;
    }
    ::v-deep .sb-icon .mask {
      background-color: #3771cb !important;
    }
  }
}

.forced-ellipsis {
  overflow: hidden;

  &:after {
    content: "...";
    position: absolute;
    right: 30px;
    top: 1px;
    background: #ffffff;
    padding: 7px 1px;
    z-index: 2;
    height: calc(100% - 2px);
    text-align: center;
  }
}

.list-operator {
  cursor: pointer;
  font-size: 12px;
  color: $blackPrimary;
  margin-right: 5px;
  text-decoration-line: underline;
  text-decoration-style: dashed;
}

::v-deep .multiselect.no-selected-background .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option.multiselect__option--selected {
  color: $blackPrimary !important;
}

::v-deep .multiselect .multiselect__tags {
  padding-right: 25px;
  .multiselect__single {
    display: flex;
  }
}
</style>
